import Input from "../../../components/ui/Input";
import Button from "../../../components/ui/buttons/Button";
import { IoIosSearch } from "react-icons/io";
import { searchProjects } from "../../../services/newApi";
import { useQuery } from "@tanstack/react-query";
import { Turnstile } from '@marsidev/react-turnstile';
import { useState } from "react";

const TURNSTILE_SECRET = process.env.REACT_APP_SITEKEY_TURNSTILE;


const ProjectSearch = ({ setTabContent, setActiveTab, setTabError, setIsSearching, setIsTabButtonVisible, searchInputValue, setSearchInputValue }) => {
    const isReactSnap = typeof navigator !== "undefined" && navigator.userAgent === "ReactSnap";
    const isDev = process.env.NODE_ENV === "development";
    const isCaptchaEnabled = !isDev && !isReactSnap;
    const { refetch } = useQuery({
        queryKey: ["project-search"],
        queryFn: async => searchProjects(searchInputValue),
        enabled: false,
    });
    const [status, setStatus] = useState(false);
    const handleSearchBtnClick = async () => {
        if (isCaptchaEnabled && status !== "solved") {
            setTabError({message: "Captcha Cloudfare incorrect"});
            return;
        }
        setActiveTab(null);
        setIsSearching(true);
        try {
            const response = await refetch();
            setIsSearching(false);
            setIsTabButtonVisible(false);

            if (response.error) {
                setTabError(response.error?.message ? response.error : { message: "Une erreur est survenue." });
                return;
            }
            if (!response.data) {
                setTabError({ message: "Aucune donnée reçue." });
                return;
            }
            setTabContent(response.data);
            setTabError(null);
        } catch (error) {
            setIsSearching(false);
            setIsTabButtonVisible(false);
            setTabError(error?.message ? error : { message: "Erreur inattendue lors de la recherche." });
        }
    };

    const handleSearchInputChange = (value) => {
        setSearchInputValue(value);
    }

    return (
        <div className="block w-full mt-16">
            <p className="mb-6 text-lg font-bold">Rechercher un projet :</p>
            <div className="gap-y-2">
                <div className="flex flex-row gap-x-3">
                    <Input type="text" onChange={handleSearchInputChange} value={searchInputValue} tailwindClass="max-w-52" />
                    <Button
                        btnType="secondaryBorder"
                        tailwinClass="px-2 py-1 text-base"
                        icon={<IoIosSearch size={25} />} iconPosition="only" hover={true} handleClick={handleSearchBtnClick} />
                </div>
                <div className="mt-2">
                    {isCaptchaEnabled && (
                        <Turnstile
                            siteKey={TURNSTILE_SECRET}
                            onError={() => setStatus('error')}
                            onExpire={() => setStatus('expired')}
                            onSuccess={() => setStatus('solved')}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

export default ProjectSearch;